import {type DataTypeProvider} from '@devexpress/dx-react-grid';

import {FormatDate} from '../../../../services/dateService';

export function OptixTableDataTypeTimeFormatter({
  value,
}: DataTypeProvider.ValueFormatterProps): JSX.Element {
  return <>{FormatDate(value, 'time')}</>;
}
